import React from "react";
import { Link } from "react-router-dom";
//import { CheckCircle } from "react-feather"; // optional if you have react-feather installed

function TreeSubscriptionSuccessful() {
  return (
    <div className="main-wrapper d-flex align-items-center justify-content-center vh-100">
      <div className="card shadow-lg text-center p-5" style={{ maxWidth: "500px", borderRadius: "20px" }}>
        
        {/* Success Icon */}
        <div className="mb-4">
         
        </div>

        {/* Title */}
        <h3 className="fw-bold text-success">Payment Successful 🎉</h3>

        {/* Message */}
        <p className="text-muted mt-3">
          Thank you for subscribing! Your payment has been processed successfully.  
          You can now log in to enjoy full access to your Family Tree app.
        </p>

        {/* Action Button */}
        <div className="d-grid gap-2 mt-4">
          {/*<Link to="/login" className="btn btn-success btn-lg rounded-pill">
            Go to Login
          </Link>*/}
        </div>

        {/* Extra Info */}
        
      </div>
    </div>
  );
}

export default TreeSubscriptionSuccessful;
